import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private keepAliveInterval!: any;
  private routerSubscription?: Subscription;

  constructor(private router: Router) {}

  ngOnInit() {
    this.startKeepAlive();
    this.trackRoute();
  }
  private trackRoute() {
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = event.urlAfterRedirects;
        if (url === '/' || url.startsWith('/?') || url.startsWith('/error')) {
          return;
        }
        sessionStorage.setItem('route', url);
      });
  }

  private startKeepAlive() {
    this.keepAliveInterval = setInterval(
      () => {
        if (window.parent) {
          window.parent.postMessage({ type: 'KEEP_ALIVE' }, '*');
        }
      },
      5 * 60 * 1000,
    );
  }

  ngOnDestroy() {
    if (this.keepAliveInterval) {
      clearInterval(this.keepAliveInterval);
    }
    this.routerSubscription?.unsubscribe();
  }
}
